var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6367 16L9.13045 10.4931C6.68099 12.2345 3.30573 11.8085 1.36572 9.51327C-0.574289 7.21802 -0.431839 3.81918 1.69342 1.69429C3.81813 -0.431535 7.21751 -0.574592 9.51333 1.3652C11.8091 3.30499 12.2353 6.68038 10.4938 9.1299L16 14.6368L14.6377 15.999L14.6367 16ZM5.78047 1.92742C3.95344 1.92701 2.37719 3.20942 2.00605 4.99825C1.6349 6.78707 2.57087 8.59066 4.24727 9.31704C5.92368 10.0434 7.87977 9.49295 8.93125 7.99891C9.98273 6.50487 9.8406 4.47789 8.59091 3.14519L9.17381 3.72323L8.51672 3.06811L8.50516 3.05655C7.78428 2.33127 6.80309 1.92466 5.78047 1.92742Z",
    fill: "#475568"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-icon.0459c43a0ca34848e41ba91fd5f6c1f7.svg";